import { useState } from "react";
import { clsx } from "clsx";

type Props = { title: string; items: { q: string; a: string }[] };

export const FAQ = ({ title, items }: Props) => {
  const [open, setOpen] = useState<number>();
  return (
    <div
      id="faq"
      className="section flex flex-col gap-[60px] rounded-[20px] bg-[#FAFAFE] pb-[112px] pt-[80px]"
    >
      <h3 className="text-center text-[34px] font-bold text-[#0E0D0D]">{title}</h3>
      <div className="flex flex-col items-center gap-[24px] px-4">
        {items.map((item, i) => (
          <div
            onClick={() => setOpen(open === i ? undefined : i)}
            key={i}
            className={clsx(
              "flex w-full max-w-[896px] cursor-pointer  flex-col gap-[17px]  rounded-[14px] bg-white p-[36px] duration-200",
              open === i && "outline-primary outline",
            )}
          >
            <div className="flex items-center justify-between">
              <h4 className="text-[16px] font-bold text-[#170F49] md:text-[18px]">{item.q}</h4>
              <Icon open={open === i} />
            </div>
            {open === i && (
              <div
                onClick={(e) => e.stopPropagation()}
                className="flex cursor-default flex-col gap-[12px] text-[18px] leading-[1.33] text-[#6F6C90]"
                dangerouslySetInnerHTML={{ __html: item.a }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
const Icon = ({ open }: { open: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    fill="none"
    className={clsx(
      " aspect-square h-[30px] shrink-0 rounded-full duration-200 md:h-[40px]",
      open ? "bg-primary rotate-90 stroke-white" : "outline-primary stroke-primary outline",
    )}
  >
    <path
      d="M17 26L23.22 19.7518L17 13.5035"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
